import client from "./config";
import { convertNum } from "helper/convert-num";
import { convertDate, convertTime, DATE_FORMATS } from "helper/date";

//////////////// login ////////////////
const loginUrl = "/admin/login";
export const login = (values) => {
  return client.post(loginUrl, {
    name: values.name,
    password: values.password,
  });
};

//////////////// stats ////////////////
const getStatusUrl = "/admin/stat";
export const getStatusRequest = () => client.get(getStatusUrl);

////////////////// User ////////////////
const usersUrl = "/admin/user";
export const getUsersRequest = (values) => {
  return client.get(`${usersUrl}?skip=${values.skip}&limit=${
    values.limit ?? 10
  }&type=${values.type}
    ${values.search ? "&search=" + convertNum(values.search) : ""}`);
};
export const getUserInfoRequest = (id) => client.get(`${usersUrl}/${id}`);
export const blockUserRequest = (values) =>
  client.post(`${usersUrl}/${values.id}/block`, {
    reason: values.message,
  });
export const unBlockUserRequest = (id) =>
  client.get(`${usersUrl}/${id}/unblock`);

export const updateUserRequest = (values, onUploadProgress) => {
  const formData = new FormData();

  formData.append("full_name", values.full_name);
  formData.append("type", "colleague");
  formData.append("phone_number", convertNum(values.phone_number));
  values.state && formData.append("state", values.state);
  values.city && formData.append("city", values.city);
  values.email && formData.append("email", values.email);
  values.postal_code && formData.append("postal_code", values.postal_code);
  values.address && formData.append("address", values.address);
  formData.append("password", convertNum(values.password));
  !values.active_card_number.isWeb &&
    formData.append("active_card_number", values.active_card_number.url);
  !values.business_license.isWeb &&
    formData.append("business_license", values.business_license.url);
  !values.rose_head_panel.isWeb &&
    formData.append("rose_head_panel", values.rose_head_panel.url);
  !values.national_card.isWeb &&
    formData.append("national_card", values.national_card.url);
  !values.first_page_of_birth_certificate.isWeb &&
    formData.append(
      "first_page_of_birth_certificate",
      values.first_page_of_birth_certificate.url
    );

  formData.append("_method", "put");

  return client.post(`${usersUrl}/${values.id}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};
export const updateNormalUserRequest = (values, onUploadProgress) => {
  const formData = new FormData();

  formData.append("full_name", values.full_name);
  values.email && formData.append("email", values.email);

  formData.append("_method", "put");

  return client.post(`${usersUrl}/${values.id}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

export const addUserRequest = (values, onUploadProgress) => {
  const formData = new FormData();

  formData.append("full_name", values.full_name);
  formData.append("type", "colleague");
  formData.append("phone_number", convertNum(values.phone_number));
  formData.append("state", values.state);
  formData.append("city", values.city);
  formData.append("email", values.email);
  formData.append("postal_code", values.postal_code);
  formData.append("address", values.address);
  formData.append("password", convertNum(values.password));
  formData.append(
    "active_card_number",
    values.active_card_number.url == null ? "" : values.active_card_number.url
  );
  formData.append(
    "business_license",
    values.business_license.url == null ? "" : values.business_license.url
  );
  formData.append(
    "rose_head_panel",
    values.rose_head_panel.url == null ? "" : values.rose_head_panel.url
  );
  formData.append(
    "national_card",
    values.national_card.url == null ? "" : values.national_card.url
  );
  formData.append(
    "first_page_of_birth_certificate",
    values.first_page_of_birth_certificate.url == null
      ? ""
      : values.first_page_of_birth_certificate.url
  );

  return client.post(usersUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

//////////////// user address ////////////////
const UserAddressUrl = "/admin/user_address";
export const getUserAddressRequest = (values) =>
  client.get(
    `${UserAddressUrl}?${values.userId ? "user_id=" + values.userId : ""}`
  );
export const getUserAddressByIdRequest = (id) =>
  client.get(`${UserAddressUrl}/${id}`);
export const updateUserAddressRequest = (values) => {
  let transformedData = {
    state: values.state,
    city: values.city,
    postal_code: values.postal_code,
    address: values.address,
  };

  return client.put(`${UserAddressUrl}/${values.id}`, transformedData);
};

//////////////// Discount ////////////////
const discountUrl = "/admin/discount_code";
export const getDiscountRequest = (values) =>
  client.get(`${discountUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`);
export const deleteDiscountRequest = (id) =>
  client.delete(`${discountUrl}/${id}`);
export const addDiscountRequest = (values) => {
  values.code = convertNum(values.code);
  values.amount = convertNum(values.amount);
  values.expires_at = convertDate({
    time: new Date(values.expires_at).setSeconds(0),
    format: DATE_FORMATS.faDate,
  }).enDate;

  return client.post(discountUrl, values);
};

//////////////// notification frame ////////////////
const notificationFrameUrl = "/admin/notification_frame";
export const getNotificationFrameRequest = (values) =>
  client.get(
    `${notificationFrameUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`
  );
export const deleteNotificationFrameRequest = (id) =>
  client.delete(`${notificationFrameUrl}/${id}`);
export const addNotificationFrameRequest = (values) => {
  let data = {
    title: values.title,
    text: values.text,
  };
  return client.post(notificationFrameUrl, data);
};

//////////////// notification ////////////////
const notificationSendUrl = "/admin/notification";
export const sendNotificationRequest = (values) => {
  let data = {
    type: values.type,
    message: values.text,
    users: values.users,
  };
  return client.post(notificationSendUrl, data);
};

////////////////// message ////////////////
const messageUrl = "/admin/contact_us_message";
export const getMessageRequest = (values) =>
  client.get(`${messageUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`);
export const getMessageUserByIdRequest = (id) =>
  client.get(`${messageUrl}/${id}`);
export const deleteMessageRequest = (id) =>
  client.delete(`${messageUrl}/${id}`);

////////////////// complaint ////////////////
const complaintUrl = "/admin/complaint";
export const getcomplaintRequest = (values) =>
  client.get(`${complaintUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`);
export const getcomplaintByIdRequest = (id) =>
  client.get(`${complaintUrl}/${id}`);
export const deletecomplaintRequest = (id) =>
  client.delete(`${complaintUrl}/${id}`);

//////////////// common question ////////////////
const common_questionUrl = "/admin/common_question";
const getcommon_questionUrl = "/common_question";
export const getQuestionRequest = (values) =>
  client.get(`${getcommon_questionUrl}`);
export const getQuestionInfoRequest = (id) =>
  client.get(`${getcommon_questionUrl}/${id}`);
export const deleteQuestionRequest = (id) =>
  client.delete(`${common_questionUrl}/${id}`);
export const addQuestionRequest = (values) => {
  let data = {
    question: values.question,
    answer: values.answer,
  };
  return client.post(common_questionUrl, data);
};
export const updateQuestionRequest = (values) => {
  let transformedData = {
    question: values.question,
    answer: values.answer,
  };
  return client.put(`${common_questionUrl}/${values.id}`, transformedData);
};

//////////////// news - article ////////////////
const articleUrl = "/admin/article";
const getarticleUrl = "/article";
export const getArticleRequest = (values) =>
  client.get(
    `${getarticleUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`
  );
export const getArticleInfoRequest = (id) =>
  client.get(`${getarticleUrl}/${id}`);
export const deleteArticleRequest = (id) =>
  client.delete(`${articleUrl}/${id}`);
export const updateArticleRequest = (values, onUploadProgress) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("file", values.file[0] == undefined ? "" : values.file[0]);
  formData.append("text", values.content);
  formData.append("article_category_id", parseInt(values.article_category_id));

  formData.append("_method", "put");

  return client.post(`${articleUrl}/${values.id}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};
export const addArticleRequest = (values, onUploadProgress) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("file", values.file[0]);
  formData.append("text", values.content);
  formData.append("article_category_id", parseInt(values.article_category_id));

  return client.post(articleUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};
//////////////// news category ////////////////
const categoryNewsUrl = "/admin/article_category";
const getCategoryNewsUrl = "/article_category";
export const getCategoryNewsRequest = (values) =>
  client.get(`${getCategoryNewsUrl}?skip=${values.skip}&limit=${
    values.limit ?? 10
  }
    ${values.search ? "&search=" + convertNum(values.search) : ""}`);
export const getCategoryNewsInfoRequest = (id) =>
  client.get(`${getCategoryNewsUrl}/${id}`);
export const deleteCategoryNewsRequest = (id) =>
  client.delete(`${categoryNewsUrl}/${id}`);
export const addCategoryNewsRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);
  return client.post(categoryNewsUrl, formData);
};
export const updateCategoryNewsRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);

  formData.append("_method", "put");

  return client.post(`${categoryNewsUrl}/${values.id}`, formData);
};

//////////////// rules ////////////////
const rulesUrl = "/admin/rules";
const getrulesUrl = "/rules";
export const getRulesRequest = () => client.get(getrulesUrl);
export const updateRulesRequest = (values) => {
  let transformedData = {
    text: values.content,
  };
  return client.put(`${rulesUrl}`, transformedData);
};

//////////////// cart message ////////////////
const cartmessageUrl = "/admin/cart_message";
const getcartmessageUrl = "/cart_message";
export const getCmessageRequest = () => client.get(getcartmessageUrl);
export const updateCmessageRequest = (values) => {
  let transformedData = {
    text: values.text,
  };
  return client.put(`${cartmessageUrl}`, transformedData);
};

//////////////// privacy ////////////////
const privacyUrl = "/admin/privacy";
const getprivacyUrl = "/privacy";
export const getPrivacyRequest = () => client.get(getprivacyUrl);
export const updatePrivacyRequest = (values) => {
  let transformedData = {
    text: values.content,
  };
  return client.put(`${privacyUrl}`, transformedData);
};

//////////////// about_us ////////////////
const aboutUsUrl = "/admin/about_us";
const getaboutUsUrl = "/about_us";
export const getaboutUsRequest = () => client.get(getaboutUsUrl);
export const updateaboutUsRequest = (values) => {
  let transformedData = {
    text: values.content,
  };
  return client.put(`${aboutUsUrl}`, transformedData);
};

//////////////// contact_us ////////////////

const ContactUsUrl = "/admin/contact_us_content";
const getContactUsUrl = "/contact_us_content";
export const getContactUsContentRequest = (values) =>
  client.get(`${getContactUsUrl}?type=${values.type}`);
export const updateContactUsContentRequest = (values) => {
  let transformedData = {
    phone_number: values.phone_number,
    address: values.address,
    instagram: values.instagram,
    telegram: values.telegram,
    email: values.email,
  };
  return client.put(`${ContactUsUrl}?type=1`, transformedData);
};
export const updateContactUsAccessoryContentRequest = (values) => {
  let transformedData = {
    phone_number: values.phone_number,
    address: values.address,
    instagram: values.instagram,
    telegram: values.telegram,
    email: values.email,
  };
  return client.put(`${ContactUsUrl}?type=2`, transformedData);
};

//////////////// category ////////////////
const categoryUrl = "/admin/category";
const getCategoryUrl = "/category";
export const getFilterCategoryRequest = (values) =>
  client.get(`${getCategoryUrl}`);
export const getCategoryRequest = (values) =>
  client.get(`${getCategoryUrl}?skip=${values.skip}&limit=${values.limit ?? 10}
    ${values.search ? "&search=" + convertNum(values.search) : ""}`);
export const getCategoryInfoRequest = (id) =>
  client.get(`${getCategoryUrl}/${id}`);
export const deleteCategoryRequest = (id) =>
  client.delete(`${categoryUrl}/${id}`);
export const addCategoryRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("type", values.type);
  return client.post(categoryUrl, formData);
};
export const updateCategoryRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("type", values.type);

  formData.append("_method", "put");

  return client.post(`${categoryUrl}/${values.id}`, formData);
};

//////////////// design ////////////////
const designUrl = "/admin/design";
const getDesignUrl = "/design";
export const getAllDesignRequest = (values) =>
  client.get(`${getDesignUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`);
export const getDesignRequest = (values) =>
  client.get(
    `${getDesignUrl}?skip=${values.skip}&limit=${
      values.limit ?? 10
    }&category_id=${values.category_id}`
  );
export const getDesignInfoRequest = (id) => client.get(`${getDesignUrl}/${id}`);
export const deleteDesignRequest = (id) => client.delete(`${designUrl}/${id}`);
export const addDesignRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("category_id", values.category_id);
  return client.post(designUrl, formData);
};
export const updateDesignRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("subcategory_id", values.subcategory_id);

  formData.append("_method", "put");

  return client.post(`${designUrl}/${values.id}`, formData);
};

//////////////// products ////////////////
const productUrl = "/admin/product";
const getProductUrl = "/product";
export const getProductsRequest = (values) => {
  return client.get(`${getProductUrl}?skip=${values.skip}&limit=${
    values.limit ?? 10
  }
    ${values.search ? "&search=" + convertNum(values.search) : ""}`);
};
export const getProductInfoRequest = (id) =>
  client.get(`${getProductUrl}/${id}`);
export const deleteProductRequest = (id) =>
  client.delete(`${productUrl}/${id}`);
export const updateProductRequest = (values, onUploadProgress) => {
  const formData = new FormData();

  formData.append("title", values.title);
  values.link && formData.append("link", values.link);
  values.content && formData.append("description", values.content);
  formData.append("design_id", values.design_id);
  formData.append("before_discount_price", values.before_discount_price);
  formData.append("colleague_price", values.colleague_price);
  formData.append("discount_percent", values.discount_percent);
  formData.append("amazing_offer", values.amazing_offer);
  !values.image.isWeb && formData.append("image", values.image.url);

  formData.append("_method", "put");

  return client.post(`${productUrl}/${values.id}`, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};
export const addProductRequest = (values, onUploadProgress) => {
  const formData = new FormData();

  formData.append("title", values.title);
  values.link && formData.append("link", values.link);
  values.content && formData.append("description", values.content);
  formData.append("design_id", values.design_id);
  formData.append("before_discount_price", values.before_discount_price);
  formData.append("colleague_price", values.colleague_price);
  values.discount_percent &&
    formData.append("discount_percent", values.discount_percent);
  formData.append("image", values.image.url);
  formData.append("amazing_offer", values.amazing_offer);

  return client.post(productUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

//////////////// products color ////////////////
const productColorUrl = "/admin/product_color";
const getProductColorUrl = "/product_color";
export const getProductsColorRequest = (values) => {
  return client.get(
    `${getProductColorUrl}?skip=${values.skip}&limit=${
      values.limit ?? 10
    }&product_id=${values.product_id}`
  );
};
export const getProductColorInfoRequest = (id) =>
  client.get(`${getProductColorUrl}/${id}`);
export const deleteProductColorRequest = (id) =>
  client.delete(`${productColorUrl}/${id}`);
export const updateProductColorRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("color_code", values.color_code);
  formData.append("stock", values.stock);
  formData.append("product_id", values.product_id);

  formData.append("_method", "put");

  return client.post(`${productColorUrl}/${values.id}`, formData);
};
export const addProductColorRequest = (values) => {
  const formData = new FormData();

  formData.append("title", values.title);
  formData.append("color_code", values.color_code);
  formData.append("stock", values.stock);
  formData.append("product_id", values.product_id);

  return client.post(productColorUrl, formData);
};

//////////////// product images ////////////////
const ProductImageUrl = "/admin/product_color_image";
const getProductImageUrl = "/product_color_image";
export const getProductImageRequest = (values) => {
  return client.get(
    `${getProductImageUrl}?product_color_id=${values.product_color_id}`
  );
};
export const deleteProductImageRequest = (id) =>
  client.delete(`${ProductImageUrl}/${id}`);
export const addProductImageRequest = (image, values, onUploadProgress) => {
  let formData = new FormData();
  formData.append("image", image);
  formData.append("product_color_id", values.product_color_id);
  return client.post(ProductImageUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

const categoriesUrl = "/category";

export const getCategoriesData = () => client.get(`${categoriesUrl}`);

export const getCategoriesTypeData = () => client.get(`${categoriesUrl}/type`);

const desingsUrl = "/design";

export const getDesingData = () => client.get(`${desingsUrl}`);

//////////////// gallary ////////////////
const galleryUrl = "/admin/gallery_image";
const getgalleryUrl = "/gallery_image";
export const getGalleryRequest = () => client.get(getgalleryUrl);
export const deleteGalleryRequest = (id) =>
  client.delete(`${galleryUrl}/${id}`);
export const addGalleryRequest = (image, onUploadProgress) => {
  let formData = new FormData();
  formData.append("image", image);

  return client.post(galleryUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

//////////////// License ////////////////
const LicenseUrl = "/admin/certificate";
const getLicenseUrl = "/certificate";
export const getLicenseRequest = () => client.get(getLicenseUrl);
export const deleteLicenseRequest = (id) =>
  client.delete(`${LicenseUrl}/${id}`);
export const addLicenseRequest = (image, onUploadProgress) => {
  let formData = new FormData();
  formData.append("image", image);

  return client.post(LicenseUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

//////////////// orders ////////////////////
const orderUrl = "/admin/order";
export const getOrdersRequest = (values) => {
  return client.get(`${orderUrl}?skip=
    ${values.skip}&limit=${values.limit ?? 10}
    ${values.search ? "&search=" + convertNum(values.search) : ""}
    ${values.userId ? "&user_id=" + values.userId : ""}
    ${values.user_type ? "&user_type=" + values.user_type : ""}
    ${values.payment_status ? "&payment_status=" + values.payment_status : ""}
    ${values.category_type ? "&category_type=" + values.category_type : ""}
    ${values.category_id ? "&category_id=" + values.category_id : ""}
    ${values.design_id ? "&design_id=" + values.design_id : ""}
    ${
      values.created_at_from
        ? "&created_at_from=" +
          (values.created_at_from = convertDate({
            time: new Date(values.created_at_from).setSeconds(0),
            format: DATE_FORMATS.faDate,
          }).enDate)
        : ""
    }
    ${
      values.created_at_to
        ? "&created_at_to=" +
          (values.created_at_to = convertDate({
            time: new Date(values.created_at_to).setSeconds(0),
            format: DATE_FORMATS.faDate,
          }).enDate)
        : ""
    }
    `);
};
export const getOrderById = (id) => client.get(`${orderUrl}/${id}`);

//////////////// orders stats ////////////////////
const orderStatsUrl = "/admin/order_stat";
export const getOrdersStatsRequest = (values) => {
  return client.get(`${orderStatsUrl}?skip=0
  ${values.search ? "&search=" + convertNum(values.search) : ""}
  ${values.user_type ? "&user_type=" + values.user_type : ""}
  ${"&payment_status=successful"}
  ${values.category_type ? "&category_type=" + values.category_type : ""}
  ${values.category_id ? "&category_id=" + values.category_id : ""}
  ${values.design_id ? "&design_id=" + values.design_id : ""}
  ${
    values.created_at_from
      ? "&created_at_from=" +
        (values.created_at_from = convertDate({
          time: new Date(values.created_at_from).setSeconds(0),
          format: DATE_FORMATS.faDate,
        }).enDate)
      : ""
  }
  ${
    values.created_at_to
      ? "&created_at_to=" +
        (values.created_at_to = convertDate({
          time: new Date(values.created_at_to).setSeconds(0),
          format: DATE_FORMATS.faDate,
        }).enDate)
      : ""
  }
    `);
};

////////////////// comment ////////////////
const commentUrl = "/admin/comment";
export const getcommentRequest = (values) =>
  client.get(`${commentUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`);
export const getcommentByIdRequest = (id) => client.get(`${commentUrl}/${id}`);
export const deletecommentRequest = (id) =>
  client.delete(`${commentUrl}/${id}`);
export const confirmcommentRequest = (id) =>
  client.get(`${commentUrl}/${id}/confirm`);

//////////////// main slide ////////////////
const MainSliderUrl = "/admin/main_slide";
const getMainSliderUrl = "/main_slide";
export const getMainSliderRequest = () => client.get(getMainSliderUrl);
export const deleteMainSliderRequest = (id) =>
  client.delete(`${MainSliderUrl}/${id}`);
export const addMainSliderRequest = (image, onUploadProgress) => {
  let formData = new FormData();
  formData.append("image", image);

  return client.post(MainSliderUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

//////////////// acc slide ////////////////
const AccSliderUrl = "/admin/accessory_slide";
const getAccSliderUrl = "/accessory_slide";
export const getAccSliderRequest = () => client.get(getAccSliderUrl);
export const deleteAccSliderRequest = (id) =>
  client.delete(`${AccSliderUrl}/${id}`);
export const addAccSliderRequest = (image, onUploadProgress) => {
  let formData = new FormData();
  formData.append("image", image);

  return client.post(AccSliderUrl, formData, {
    onUploadProgress: (progress) =>
      onUploadProgress((progress.loaded / progress.total) * 100),
  });
};

////////////////// ticket ////////////////
const ticketUrl = "/admin/ticket";
const EditticketUrl = "/admin/ticket_message";
export const getticketRequest = (values) =>
  client.get(`${ticketUrl}?skip=${values.skip}&limit=${values.limit ?? 10}`);
export const getticketByIdRequest = (id) => client.get(`${ticketUrl}/${id}`);
export const EditTicketRequest = (values) => {
  const formData = new FormData();

  formData.append("ticket_id", values.ticket_id);
  formData.append("file", values.file[0] == undefined ? "" : values.file[0]);
  formData.append("text", values.text);

  return client.post(EditticketUrl, formData);
};
export const getCloseticketByIdRequest = (id) =>
  client.get(`${ticketUrl}/${id}/close`);

// ////////////////// Question ////////////////
const QuestionByIdUrl = "/admin/question_and_answer";
export const getQuestionAnswerRequest = (values) =>
  client.get(
    `${QuestionByIdUrl}?skip=${values.skip}&limit=${
      values.limit ?? 10
    }&is_question=1`
  );

export const getQuestionAnswerByIdRequest = (id) =>
  client.get(`${QuestionByIdUrl}/${id}`);

export const deleteQuestionAnswerRequest = (id) =>
  client.delete(`${QuestionByIdUrl}/${id}`);
export const confirmQuestionAnswerRequest = (id) =>
  client.get(`${QuestionByIdUrl}/${id}/confirm`);

export const getAnswersRequest = (values) =>
  client.get(`${QuestionByIdUrl}?question_id=${values.question_id}`);

////////////////// Answer ////////////////

export const addAnswerRequest = (values) => {
  let data = {
    text: values.answer,
    question_id: values.question_id,
  };
  return client.post(QuestionByIdUrl, data);
};

/////////////// views ///////////////////////
const getViewsUrl = "/admin/view";
export const getViewProductsRequest = (values) => {
  return client.get(
    `${getViewsUrl}${values.type ? "?type=" + values.type : ""}`
  );
};

//////////////// branch ////////////////
const branchUrl = "/admin/branches";
const getbranchUrl = "/branches";
export const getbranchRequest = () => client.get(getbranchUrl);
export const updatebranchRequest = (values) => {
  let transformedData = {
    text: values.content,
  };
  return client.put(`${branchUrl}`, transformedData);
};

//////////////// pay rules ////////////////
const how_to_orderUrl = "/admin/how_to_order";
const gethow_to_orderUrl = "/how_to_order";
export const gethow_to_orderUrlRequest = () => client.get(gethow_to_orderUrl);
export const updatehow_to_orderUrlRequest = (values) => {
  let transformedData = {
    text: values.content,
  };
  return client.put(`${how_to_orderUrl}`, transformedData);
};
